(function() {
  'use strict';

  // Variant ID lijsten — beide ondersteund voor backwards compat + future-proof
  var hariboIds = (window.__HARIBO_DEAL_VARIANT_IDS__ || []).map(String);
  var specialIds = (window.__SPECIAL_DEAL_VARIANT_IDS__ || []).map(String);
  var dealSet = {};
  hariboIds.forEach(function(id) { dealSet[id] = true; });
  specialIds.forEach(function(id) { dealSet[id] = true; });

  function isDealVariant(id) {
    return !!dealSet[String(id)];
  }

  // Bundle/multi-buy uitzonderingen: deze handles MOGEN qty > 1 hebben ook al
  // hebben ze (per ongeluk) product_type='limit-1'. Dit voorkomt dat de
  // Dubai-repen builder terug-springt naar qty=1 in de cart drawer.
  var BUNDLE_EXEMPT_HANDLES = {
    'dubai-chocolade-reep-puur-pistache-knafeh-220g': true,
    'dubai-chocolade-reep-melk-pistache-knafeh-220g': true,
    'dubai-chocolade-reep-wit-pistache-knafeh-220g': true,
    '1-kilo': true,
    'bueno-bliss-barr': true,
    'fudgy-brownie': true,
    'the-chips-choc-bar-peanut-butter-salty-chips-220-gram': true,
    'peanutbutter-fudge-bar': true,
    'pismanye-bar-dubai-1': true
  };
  function isBundleExempt(item) {
    return !!(item && item.handle && BUNDLE_EXEMPT_HANDLES[item.handle]);
  }

  // Een item is een "special deal" als:
  //  - variant in lijst, OF
  //  - properties._special_deal === 'true' (generiek, future-proof), OF
  //  - properties._haribo_deal === 'true' (legacy), OF
  //  - product_type === 'limit-1' (alle [DEAL] én losse acties zoals €2 super snoep)
  // Bundle-exempt items worden NOOIT als deal beschouwd.
  function itemIsSpecialDeal(item) {
    if (isBundleExempt(item)) return false;
    if (isDealVariant(item.variant_id || item.id)) return true;
    var props = item.properties || {};
    if (props._special_deal === 'true' || props._special_deal === true) return true;
    if (props._haribo_deal === 'true' || props._haribo_deal === true) return true;
    var pType = (item.product_type || '').toLowerCase();
    if (pType === 'limit-1') return true;
    return false;
  }

  function payloadItemIsSpecialDeal(it) {
    var id = it.id || it.variant_id;
    if (isDealVariant(id)) return true;
    var props = it.properties || {};
    if (props._special_deal === 'true' || props._special_deal === true) return true;
    if (props._haribo_deal === 'true' || props._haribo_deal === true) return true;
    return false;
  }

  var originalFetch = window.fetch.bind(window);

  // Cache van laatste cart state om snel pre-check te doen
  var cachedCart = null;
  var cacheTimestamp = 0;
  function refreshCachedCart() {
    return originalFetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(c) { cachedCart = c; cacheTimestamp = Date.now(); return c; })
      .catch(function() { return null; });
  }
  refreshCachedCart();

  // Expose: cart heeft al een special deal? Wordt door mpo-modal en
  // andere "limit-1 per klant" popups gechecked om te suppressen wanneer
  // deal-guard het conflict toch al afhandelt.
  window.__cartHasSpecialDeal = function() {
    if (!cachedCart || !cachedCart.items) return false;
    for (var i = 0; i < cachedCart.items.length; i++) {
      if (itemIsSpecialDeal(cachedCart.items[i])) return true;
    }
    return false;
  };

  function cartHasSpecialDeal(cart) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (itemIsSpecialDeal(cart.items[i])) return cart.items[i];
    }
    return null;
  }

  function capAddBody(body) {
    if (!body) return { body: body, changed: false };
    var items = body.items ? body.items : [body];
    var changed = false;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (payloadItemIsSpecialDeal(it) && (it.quantity || 1) > 1) {
        it.quantity = 1;
        changed = true;
      }
    }
    return { body: body, changed: changed };
  }

  // Modal stacking guard — als modal al open staat, hergebruik diens promise
  var activeModalPromise = null;

  // Pre-check: blokkeert add van 2e special deal en toont modal
  // Returns Promise<boolean> — true = mag doorgaan, false = geblokkeerd
  function preCheckAdd(parsedBody) {
    var items = parsedBody.items ? parsedBody.items : [parsedBody];
    var hasNewSpecial = items.some(payloadItemIsSpecialDeal);
    if (!hasNewSpecial) return Promise.resolve(true);

    // Quick path: cache vers (<3s) én geen specials → geen fetch nodig
    var fresh = (Date.now() - cacheTimestamp) < 3000;
    var cachedHas = cachedCart ? cartHasSpecialDeal(cachedCart) : null;
    var cartPromise = (fresh && cachedCart && !cachedHas)
      ? Promise.resolve(cachedCart)
      : refreshCachedCart();

    return cartPromise.then(function(cart) {
      var existing = cartHasSpecialDeal(cart);
      if (!existing) return true;

      var newItem = items.find(payloadItemIsSpecialDeal);
      var newId = String(newItem.id || newItem.variant_id);
      // Zelfde variant? Geen conflict — qty cap is al gedaan
      if (String(existing.variant_id) === newId) return true;

      // Conflict — toon modal en wacht op keuze (1 modal max)
      if (!activeModalPromise) {
        activeModalPromise = showDealConflictModal(existing, newItem);
        activeModalPromise.then(function() { activeModalPromise = null; }, function() { activeModalPromise = null; });
      }
      return activeModalPromise.then(function(choice) {
        if (choice === 'replace') {
          return originalFetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: existing.key, quantity: 0 })
          }).then(function() { return true; }).catch(function() { return false; });
        }
        return false;
      });
    });
  }

  // Custom error voor blocked adds — callers kunnen dit detecteren
  function DealBlockedError() {
    this.name = 'DealBlockedError';
    this.message = 'Max. 1 actiedeal per bestelling';
    this.dealBlocked = true;
  }
  DealBlockedError.prototype = Object.create(Error.prototype);
  window.DealBlockedError = DealBlockedError;

  window.fetch = function(input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCartWrite = /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url);
    var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);

    if (isAdd && init && init.body) {
      var parsed = null;
      try {
        parsed = typeof init.body === 'string' ? JSON.parse(init.body) : null;
      } catch (e) { parsed = null; }

      if (parsed) {
        var capped = capAddBody(parsed);
        if (capped.changed) {
          init = Object.assign({}, init, { body: JSON.stringify(parsed) });
        }
        return preCheckAdd(parsed).then(function(allow) {
          if (!allow) {
            // Reject zodat callers .catch fired en niet per ongeluk success-state zetten
            return Promise.reject(new DealBlockedError());
          }
          init = Object.assign({}, init, { body: JSON.stringify(parsed) });
          var p = originalFetch(input, init);
          p.then(function() { setTimeout(function() { refreshCachedCart(); validateCart(); }, 120); }, function() {});
          return p;
        });
      }
    }

    var pNorm = originalFetch(input, init);
    if (isCartWrite) {
      pNorm.then(function() { setTimeout(function() { refreshCachedCart(); validateCart(); }, 120); }, function() {});
    }
    return pNorm;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    this.__cdgUrl = url;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function() {
    var self = this;
    var u = self.__cdgUrl || '';
    if (/\/cart\/(add|change|update)(\.js)?(\?|$)/.test(u)) {
      self.addEventListener('load', function() {
        setTimeout(function() { refreshCachedCart(); validateCart(); }, 120);
      });
    }
    return origSend.apply(this, arguments);
  };

  // Props naar stabiele string-signatuur. Gebruikt om te checken of twee
  // cart-lines EXACT identieke line-item-properties hebben (dan mogen ze
  // worden gemerged; bundles met afwijkende props blijven apart).
  function stableStringifyProps(props) {
    if (!props || typeof props !== 'object') return '';
    var keys = Object.keys(props).sort();
    var out = [];
    for (var i = 0; i < keys.length; i++) out.push(keys[i] + '=' + String(props[keys[i]]));
    return out.join('|');
  }

  // Detecteert of een cartline een line-level Shopify discount heeft (BxGy
  // "Koop 2 krijg 1 gratis" enz.). Shopify houdt deze bewust apart als 2e
  // cartline; wij mogen die NIET mergen met de full-price lijn van dezelfde
  // variant — dat veroorzaakt een infinite split/merge loop en de qty in de
  // drawer springt terug naar de pre-promo waarde.
  function lineHasShopifyDiscount(it) {
    if (!it) return false;
    if (typeof it.line_level_total_discount === 'number' && it.line_level_total_discount > 0) return true;
    if (Array.isArray(it.line_level_discount_allocations) && it.line_level_discount_allocations.length > 0) return true;
    if (typeof it.total_discount === 'number' && it.total_discount > 0) return true;
    if (Array.isArray(it.discounts) && it.discounts.length > 0) return true;
    return false;
  }

  var validating = false;
  var pendingValidate = false;
  function validateCart() {
    if (validating) { pendingValidate = true; return; }
    validating = true;
    pendingValidate = false;

    originalFetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cachedCart = cart;
        cacheTimestamp = Date.now();
        var fixes = [];
        var firstDealIdx = -1;
        var hasDealViolation = false;
        // Map signatuur → eerste regel info, voor het detecteren van non-deal
        // dupes (zelfde variant + identieke properties = moeten 1 regel zijn).
        var firstBySig = {};
        var mergeTargets = {}; // sig → { firstKey, totalQty }

        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          var isDeal = itemIsSpecialDeal(item);
          var pType = (item.product_type || '').toLowerCase();
          var isLimit1 = (pType === 'limit-1' || pType.indexOf('limit-1') === 0) && !isBundleExempt(item);

          if (isDeal && firstDealIdx !== -1) {
            fixes.push({ key: item.key, quantity: 0 });
            hasDealViolation = true;
          } else if (isDeal && item.quantity > 1) {
            fixes.push({ key: item.key, quantity: 1 });
            firstDealIdx = i;
            hasDealViolation = true;
          } else if (isDeal) {
            firstDealIdx = i;
          } else if (isLimit1 && item.quantity > 1) {
            fixes.push({ key: item.key, quantity: 1 });
            hasDealViolation = true;
          } else if (!isDeal && !isLimit1) {
            // Regular item — consolideer zelfde variant + identieke props
            // Skip lines met line-level Shopify discount (BxGy "gratis" lijn):
            // Shopify houdt deze bewust apart, mergen → split-loop → qty terugspring.
            if (lineHasShopifyDiscount(item)) continue;
            var sig = String(item.variant_id) + '::' + stableStringifyProps(item.properties);
            if (firstBySig[sig] == null) {
              firstBySig[sig] = { firstKey: item.key, totalQty: item.quantity };
            } else {
              // Dupe gevonden — markeer target voor consolidatie
              fixes.push({ key: item.key, quantity: 0 });
              firstBySig[sig].totalQty += item.quantity;
              mergeTargets[sig] = firstBySig[sig];
            }
          }
        }

        // Queue de totale qty op de eerste regel van elke merge-groep
        Object.keys(mergeTargets).forEach(function(sig) {
          var tgt = mergeTargets[sig];
          fixes.push({ key: tgt.firstKey, quantity: tgt.totalQty });
        });

        if (fixes.length === 0) {
          validating = false;
          if (pendingValidate) setTimeout(validateCart, 50);
          return;
        }

        // Toast tonen we alleen voor échte deal-violations; stille dupe-merges
        // zijn een onderliggende fix die de klant niet hoeft te zien.
        if (hasDealViolation) showDealToast();
        var chain = Promise.resolve();
        fixes.forEach(function(f) {
          chain = chain.then(function() {
            return originalFetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ id: f.key, quantity: f.quantity })
            });
          });
        });
        chain
          .then(function() {
            validating = false;
            refreshCachedCart();
            document.dispatchEvent(new CustomEvent('cart:deal-corrected'));
            if (window.candyCartDrawer && typeof window.candyCartDrawer.refresh === 'function') {
              window.candyCartDrawer.refresh();
            }
            if (typeof window.checkHariboInCart === 'function') window.checkHariboInCart();
            if (pendingValidate) setTimeout(validateCart, 50);
          })
          .catch(function() { validating = false; if (pendingValidate) setTimeout(validateCart, 50); });
      })
      .catch(function() { validating = false; if (pendingValidate) setTimeout(validateCart, 50); });
  }

  function cartHasDealRuleViolation(cart) {
    if (!cart || !cart.items) return false;
    var seenDeal = false;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var isDeal = itemIsSpecialDeal(item);
      var pType = (item.product_type || '').toLowerCase();
      var isLimit1 = (pType === 'limit-1' || pType.indexOf('limit-1') === 0) && !isBundleExempt(item);
      if (isDeal && seenDeal) return true;
      if (isDeal) seenDeal = true;
      if ((isDeal || isLimit1) && item.quantity > 1) return true;
    }
    return false;
  }

  function showMinimumOrderMessage() {
    var msg = document.getElementById('CartMinimumOrderMessage');
    if (msg) {
      msg.removeAttribute('hidden');
      msg.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }
    alert('Minimum bestelbedrag is €20.');
  }

  function interceptCheckout(e) {
    var target = e.target && e.target.closest ? e.target.closest('#checkout, button[name="checkout"], [name="checkout"]') : null;
    if (!target || target.__dealGuardAllowCheckout) return;

    e.preventDefault();
    e.stopPropagation();

    originalFetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cachedCart = cart;
        cacheTimestamp = Date.now();

        if (cart && cart.item_count > 0 && cart.total_price < 2000) {
          showMinimumOrderMessage();
          return;
        }

        if (cartHasDealRuleViolation(cart)) {
          validateCart();
          showDealToast();
          setTimeout(function() { window.location.reload(); }, 900);
          return;
        }

        target.__dealGuardAllowCheckout = true;
        var form = target.form || target.closest('form');
        if (form && typeof form.requestSubmit === 'function') form.requestSubmit(target);
        else if (form) form.submit();
        else window.location.href = '/checkout';
      })
      .catch(function() {
        target.__dealGuardAllowCheckout = true;
        var form = target.form || target.closest('form');
        if (form) form.submit();
        else window.location.href = '/checkout';
      });
  }

  var toastTimer = null;
  function showDealToast() {
    // Markeer suppressie + sluit een eventueel net-geopende MPO modal —
    // als validateCart() retroactief een dubbele deal corrigeert is dat ook
    // een dubbele-popup scenario (MPO + toast). Behandel dit hetzelfde als
    // de pre-check modal flow.
    window.__dealGuardActiveAt = Date.now();
    window.__dealGuardOpen = true;
    setTimeout(function() { window.__dealGuardOpen = false; }, 5000);
    if (typeof window.closeMpoModal === 'function') {
      try { window.closeMpoModal(); } catch (e) {}
    }
    var existing = document.getElementById('cart-deal-guard-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.id = 'cart-deal-guard-toast';
    toast.textContent = 'Max. 1 actiedeal per bestelling';
    toast.style.cssText = 'position:fixed;left:50%;bottom:32px;transform:translateX(-50%);background:#1a1a1a;color:#fff;padding:12px 20px;border-radius:10px;font:600 14px/1.3 system-ui,sans-serif;box-shadow:0 8px 24px rgba(0,0,0,0.25);z-index:99999;opacity:0;transition:opacity 200ms ease;pointer-events:none;';
    document.body.appendChild(toast);
    requestAnimationFrame(function() { toast.style.opacity = '1'; });

    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function() {
      toast.style.opacity = '0';
      setTimeout(function() { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 300);
    }, 2800);
  }

  // Huistijl modal voor deal-conflict
  // Returns Promise<'replace'|'keep'>
  function showDealConflictModal(existingItem, newItemPayload) {
    // Markeer dat deal-guard modal actief is — andere modals (zoals mpo "max 1 per klant")
    // checken dit en slaan zichzelf over zodat de klant geen 2 popups achter elkaar krijgt.
    window.__dealGuardActiveAt = Date.now();
    window.__dealGuardOpen = true;
    // Sluit MPO modal als die om wat voor reden dan ook al open staat
    // (race-condition: andere codepath kon MPO openen vóór deal-guard).
    if (typeof window.closeMpoModal === 'function') {
      try { window.closeMpoModal(); } catch (e) {}
    }
    return new Promise(function(resolve) {
      var rawTitle = existingItem.product_title || existingItem.title || 'Huidige actiedeal';
      // Strip [DEAL] / (DEAL) prefix uit titel — interne tag, niet voor klant
      var existingTitle = rawTitle.replace(/^\s*[\[\(]\s*DEAL\s*[\]\)]\s*/i, '').trim();

      var overlay = document.createElement('div');
      overlay.id = 'cart-deal-modal-overlay';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-labelledby', 'cart-deal-modal-title');
      overlay.style.cssText = [
        'position:fixed', 'inset:0', 'background:rgba(20,10,30,0.55)',
        'backdrop-filter:blur(4px)', '-webkit-backdrop-filter:blur(4px)',
        'z-index:100000', 'display:flex', 'align-items:center', 'justify-content:center',
        'padding:20px', 'opacity:0', 'transition:opacity 200ms ease',
        'font-family:system-ui,-apple-system,Segoe UI,sans-serif'
      ].join(';') + ';';

      var modal = document.createElement('div');
      modal.style.cssText = [
        'background:linear-gradient(180deg,#fff 0%,#fff5fa 100%)',
        'border-radius:22px', 'padding:28px 26px 22px', 'max-width:440px', 'width:100%',
        'box-shadow:0 24px 60px rgba(214,51,132,0.25),0 8px 20px rgba(0,0,0,0.12)',
        'border:2px solid #ffd1e3', 'transform:scale(0.94)',
        'transition:transform 220ms cubic-bezier(0.34,1.56,0.64,1)',
        'text-align:center', 'position:relative'
      ].join(';') + ';';

      modal.innerHTML = '' +
        '<h3 id="cart-deal-modal-title" style="margin:0 0 10px;font-size:20px;font-weight:800;color:#1a1a1a;letter-spacing:-0.01em;">Maar 1 actiedeal per bestelling</h3>' +
        '<p style="margin:0 0 18px;font-size:14.5px;line-height:1.5;color:#555;">' +
          'Je hebt al <strong style="color:#d63384;">' + escapeHtml(existingTitle) + '</strong> in je winkelmand. ' +
          'Per bestelling kun je maximaal <strong>1 speciale actiedeal</strong> kiezen. Wil je je huidige deal vervangen?' +
        '</p>' +
        '<div style="display:flex;flex-direction:column;gap:10px;">' +
          '<button type="button" id="cart-deal-modal-keep" style="' +
            'background:linear-gradient(135deg,#ff5fa2 0%,#d63384 100%);color:#fff;border:0;border-radius:14px;' +
            'padding:14px 18px;font-size:15px;font-weight:700;cursor:pointer;' +
            'box-shadow:0 6px 16px rgba(214,51,132,0.35);transition:transform 120ms ease,box-shadow 120ms ease;' +
          '">Nee, behoud huidige deal</button>' +
          '<button type="button" id="cart-deal-modal-replace" style="' +
            'background:#fff;color:#444;border:2px solid #e5e5e5;border-radius:14px;' +
            'padding:12px 18px;font-size:14px;font-weight:600;cursor:pointer;transition:border-color 120ms ease;' +
          '">Ja, vervang door nieuwe deal</button>' +
        '</div>' +
        '<button type="button" id="cart-deal-modal-close" aria-label="Sluiten" style="' +
          'position:absolute;top:12px;right:12px;background:transparent;border:0;width:32px;height:32px;' +
          'border-radius:50%;cursor:pointer;font-size:20px;color:#999;display:flex;align-items:center;justify-content:center;' +
        '">&times;</button>';

      overlay.appendChild(modal);
      document.body.appendChild(overlay);

      requestAnimationFrame(function() {
        overlay.style.opacity = '1';
        modal.style.transform = 'scale(1)';
      });

      var done = false;
      function finish(choice) {
        if (done) return;
        done = true;
        // Refresh timestamp bij sluiten — zo begint het suppressie-venster
        // voor de mpo "max 1 per klant" modal pas NA de keuze van de klant,
        // niet vanaf het moment dat de deal-guard modal opende.
        window.__dealGuardActiveAt = Date.now();
        // Open-flag pas na 5s clearen, zodat ook trage netwerk-roundtrips
        // (cart change + cart add + cart fetch) binnen de suppressie vallen.
        setTimeout(function() { window.__dealGuardOpen = false; }, 5000);
        overlay.style.opacity = '0';
        modal.style.transform = 'scale(0.94)';
        setTimeout(function() {
          if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
          document.removeEventListener('keydown', onKey);
        }, 200);
        resolve(choice);
      }

      function onKey(e) { if (e.key === 'Escape') finish('keep'); }
      document.addEventListener('keydown', onKey);

      modal.querySelector('#cart-deal-modal-replace').addEventListener('click', function() { finish('replace'); });
      modal.querySelector('#cart-deal-modal-keep').addEventListener('click', function() { finish('keep'); });
      modal.querySelector('#cart-deal-modal-close').addEventListener('click', function() { finish('keep'); });
      overlay.addEventListener('click', function(e) { if (e.target === overlay) finish('keep'); });

      var keepBtn = modal.querySelector('#cart-deal-modal-keep');
      keepBtn.addEventListener('mouseenter', function() {
        keepBtn.style.transform = 'translateY(-1px)';
        keepBtn.style.boxShadow = '0 8px 20px rgba(214,51,132,0.45)';
      });
      keepBtn.addEventListener('mouseleave', function() {
        keepBtn.style.transform = '';
        keepBtn.style.boxShadow = '0 6px 16px rgba(214,51,132,0.35)';
      });
      var replaceBtn = modal.querySelector('#cart-deal-modal-replace');
      replaceBtn.addEventListener('mouseenter', function() {
        replaceBtn.style.borderColor = '#d63384';
        replaceBtn.style.color = '#d63384';
      });
      replaceBtn.addEventListener('mouseleave', function() {
        replaceBtn.style.borderColor = '#e5e5e5';
        replaceBtn.style.color = '#444';
      });
    });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', validateCart);
  } else {
    validateCart();
  }
  document.addEventListener('click', interceptCheckout, true);
})();
